import { Button, Modal, message } from 'antd';
import close from '../../../../assets/RoundedClose.svg';
import { useDeleteScoreCardResponseMutation } from '../../../../api/tenders';
import { Loader } from '../../../Loader/Loader';
import { Dispatch, SetStateAction, useEffect } from 'react';

type DeleteModalProps = {
    data: { id: number; user_name?: string } | null;
    setOpenModal: (value: false | null) => void;
    tenderId: number | string | undefined;
    setTrigger: Dispatch<SetStateAction<boolean>>;
};

export const DeleteModal = ({ data, setOpenModal, tenderId, setTrigger }: DeleteModalProps) => {
    const [deleteScoreCardResponse, { isLoading, isSuccess }] = useDeleteScoreCardResponseMutation();

    useEffect(() => {
        if (isSuccess) {
            message.success('Completed scorecard deleted');
            setOpenModal(false);
            setTrigger((prev: boolean) => !prev);
        }
    }, [isSuccess]);

    const handleDelete = async () => {
        if (tenderId == null || data?.id == null) {
            return;
        }
        try {
            await deleteScoreCardResponse({ tender_id: tenderId, response: data.id }).unwrap();
        } catch {
            message.error('Could not delete scorecard');
        }
    };

    return (
        <Modal
            className="modal-modal"
            destroyOnClose
            centered
            open={!!data}
            onCancel={() => setOpenModal(false)}
            closeIcon={<img src={close} />}
            footer={
                <div style={{ display: 'flex', justifyItems: 'space-between', gap: '16px', width: '100%' }}>
                    <Button
                        block
                        key="back"
                        onClick={() => {
                            setOpenModal(false);
                        }}
                        className="cancel"
                    >
                        Cancel
                    </Button>
                    <Button block key="submit" type="primary" loading={isLoading} onClick={handleDelete}>
                        {isLoading ? <Loader /> : 'Delete'}
                    </Button>
                </div>
            }
        >
            <div className="modal">
                <div className="modal__header meeting" style={{ height: '88px' }}>
                    <div className="modal__title">Delete Completed Scorecard</div>
                </div>

                <div className="modal__main main" style={{ padding: '24px 56px 43px 56px' }}>
                    <div className="main__minititle">
                        Are you sure you want to delete the Completed Scorecard by <span>{data?.user_name}</span>? This
                        action cannot be undone.
                    </div>
                </div>
            </div>
        </Modal>
    );
};
